<template>
	<v-app>
		<v-app-bar color="white" height="100" absolute clipped-left flat app>
			<v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>

			<v-toolbar-title style="max-width: 200px">
				<v-img v-if="$root.selectedExperience.logo" max-height="90" contain :src="$root.asset($root.selectedExperience.logo)"></v-img>
				<span v-else @click="$store.commit('debug')">
					{{
					$store.state.principal.tenantName
					}}
				</span>
			</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-list two-line subheader>
				<v-list-item>
					<v-list-item-content class="text-right">
						<v-list-item-title>
							{{
							$store.state.principal.firstName &&
							$store.state.principal.firstName +
							" " +
							$store.state.principal.lastName
							}}
						</v-list-item-title>
						<v-list-item-subtitle>
							<a @click="logout">Logout</a>
						</v-list-item-subtitle>
					</v-list-item-content>

					<v-menu rounded="xl">
						<template v-slot:activator="{ on, attrs }">
							<v-list-item-avatar size="60" v-bind="attrs" v-on="on">
								<v-img
									v-if="$store.state.principal.image && !imgError"
									:src="
										baseLocation +
										'/asset/file/user/' +
										$store.state.principal.image
									"
									@error="imgError = !imgError"
								></v-img>
								<v-icon v-else size="60">mdi-account-circle</v-icon>
							</v-list-item-avatar>
						</template>

						<v-list flat elevation="0">
							<v-subheader>Account</v-subheader>
							<v-list-item :to="
									'/tenant/' +
									$store.state.principal.tenantSlug +
									'/profile'
								" link>
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-face-profile</v-icon>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-title>Edit Profile</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item :to="
									'/tenant/' +
									$store.state.principal.tenantSlug +
									'/changepassword'
								" link>
								<v-list-item-icon class="mr-4">
									<v-icon>mdi-lock-reset</v-icon>
								</v-list-item-icon>

								<v-list-item-content>
									<v-list-item-title>Change Password</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-list-item>
			</v-list>
		</v-app-bar>

		<v-navigation-drawer
			app
			v-model="drawer"
			:mini-variant.sync="mini"
			color="primary"
			clipped
			absolute
			height="100%"
			:permanent="$vuetify.breakpoint.mdAndUp"
			dark
			style="z-index: 2"
		>
			<v-list v-if="!$route.params.experienceId">
				<v-list-item @click="active = false" :to="'/tenant/dashboard'" link>
					<v-list-item-icon>
						<v-icon>mdi-view-dashboard</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Dashboard</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-list-item @click="active = false" :to="'/tenant/experience'" link>
					<v-list-item-icon>
						<v-icon>mdi-calendar-star</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Experience</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item @click="active = false" :to="'/tenant/staff'" link>
					<v-list-item-icon>
						<v-icon>mdi-account</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Staff</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item @click="active = false" :to="'/tenant/training'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-school-outline</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Training</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item @click="active = false" :to="'/tenant/trainingAndTutorial'" link>
					<v-list-item-icon>
						<v-icon>mdi-message-bookmark</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Training & Tutorial</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item @click="active = false" :to="'/tenant/zoomSettings'" link>
					<v-list-item-icon>
						<v-icon>mdi-video</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Zoom Setting</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item @click="active = false" :to="'/tenant/analytics'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-chart-line</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Analytics</v-list-item-title>
					</v-list-item-content>
				</v-list-item>


				<v-list-item @click="showDialogHelp = true" link>
					<v-list-item-icon>
						<v-icon>mdi-help-circle-outline</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>Help</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
			<v-list v-else>
				<v-list-item @click="deselectExperience()">
					<v-list-item-icon>
						<v-icon>mdi-chevron-left</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							{{
							$root.selectedExperience.name
							}}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/dashboard'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-view-dashboard</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Dashboard</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/structure'" link>
					<v-list-item-icon>
						<v-icon>mdi-home-edit</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Room</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/user'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-account-group</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>User</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/businessName'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-domain</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Business Name</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/ticket'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-ticket</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Ticket</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="$store.state.principal.type == 'Exhibition'" 
					:to="
						'/tenant/experience/' + experienceId + '/emailtemplate'
					" link>
					<v-list-item-icon>
						<v-icon>mdi-email-edit-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>E-mail Template</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/track'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-arrow-decision</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Auditorium</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/presentation'"
					link
					v-if="$store.state.principal.type == 'Exhibition'"
				>
					<v-list-item-icon>
						<v-icon>mdi-television-play</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Presentation</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/schedule'"
					link
					v-if="$store.state.principal.type == 'Exhibition'"
				>
					<v-list-item-icon>
						<v-icon>mdi-calendar-clock</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Schedule</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/chat/list'"
					link
					v-if="$store.state.principal.type == 'Exhibition'"
				>
					<v-list-item-icon>
						<v-icon>mdi-comment-multiple-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Chat Room</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item :to="'/tenant/experience/' + experienceId + '/booth'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-cube-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Booth</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/leaderboard'"
					link
					v-if="$store.state.principal.type == 'Exhibition'"
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-flag</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color: white !important">Leaderboard</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				
				<v-list-item :to="'/tenant/experience/' + experienceId + '/poster'" link v-if="$store.state.principal.type == 'Exhibition'">
					<v-list-item-icon>
						<v-icon>mdi-image-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Poster</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/uploadedFile'"
					link
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-upload</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color: white !important">Uploaded File</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/customColors'"
					link
					v-if="$store.state.principal.type == 'Exhibition'"
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-palette</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color: white !important">Custom Colors</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/interests'"
					link
					v-if="$store.state.principal.type == 'Exhibition'"
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-lightbulb</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color: white !important">Interests</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-group
					:value="false"
					color="white"
					prepend-icon="mdi-chart-areaspline"
					v-if="$store.state.principal.type == 'Exhibition'"
					
				>
					<template v-slot:activator>
						<v-list-item-content>
							<v-list-item-title style="color: white !important">Reporting</v-list-item-title>
						</v-list-item-content>
					</template>

					<v-list-item
						@click="active = false"
						:to="
							'/tenant/experience/' +
							experienceId +
							'/report/experienceReport'
						"
						link
						v-if="$store.state.principal.type == 'Exhibition'"
						style="margin-left:30px"
					>
						<v-list-item-icon>
							<v-icon>mdi-chart-areaspline</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title style="color: white !important" >Report</v-list-item-title>
						</v-list-item-content>
						
					</v-list-item>

					<v-list-item
						@click="active = false"
						:to="
							'/tenant/experience/' + experienceId + '/chat/log/group'
						"
						link
						v-if="$store.state.principal.type == 'Exhibition'"
						style="margin-left:30px"
					>
						<v-list-item-icon>
							<v-icon>mdi-clipboard-text</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>     Public Log</v-list-item-title>
						</v-list-item-content>
					</v-list-item>

					<v-list-item
						@click="active = false"
						:to="
							'/tenant/experience/' + experienceId + '/chat/log/user'
						"
						link
						v-if="$store.state.principal.type == 'Exhibition'"
						style="margin-left:30px"
					>
						<v-list-item-icon>
							<v-icon>mdi-clipboard-text</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title>Private Log</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-group>

				<v-list-item
					@click="showDialogHelp = true"
					link
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-help-circle-outline</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color: white !important">Help</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item
					v-if="$store.state.principal.type == 'Exhibition'"
					@click="active = false"
					:to="'/tenant/experience/' + experienceId + '/notification'"
					link
				>
					<v-list-item-icon style="color: white !important">
						<v-icon>mdi-bell-ring</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="color: white !important">Notification</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

			</v-list>
		</v-navigation-drawer>
		<v-main style="background-color: #ecf0f5">
			<v-container fluid>
				<router-view></router-view>
			</v-container>
		</v-main>

		<v-dialog v-model="showDialogHelp" content-class="col-sm-6 col-12 hide-box-shadow" persistent>
			<v-card rounded="xl" dark color="#363636">
				<v-card-title>
					<span style="font-size: 14px" class="d-flex justify-center">
						<v-icon medium>mdi-help-circle-outline</v-icon>
						<span class="ml-2">Help</span>
					</span>
					<v-spacer></v-spacer>
					<v-icon @click=" isSendMessage = false;showDialogHelp = false;">mdi-close-circle-outline</v-icon>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text v-if="!isSendMessage" style="margin-top:20px">
					<form @submit.prevent="sendMessage">
						<v-textarea label="Message" v-model="message" :rules="[(v) => !!v || 'Message is required']" required></v-textarea>
						<div class="d-flex justify-end">
							<v-btn type="submit">SEND</v-btn>
						</div>
					</form>
				</v-card-text>
				<v-card-text v-else style="margin-top:20px">
					<h3>Thank you for contacting our V-Unite support team! One of our team members will be in touch as soon as possible to address this issue. </h3>
					<br>
					<h3> The V-Unite Team </h3>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="$store.state.notification.show" width="500">
			<v-card style="padding: 20px">
				<!-- <div style="display: flex; justify-content: space-between">
					<h2 style="margin-bottom: 10px">Whoops! ({{ $store.state.notification.title }})</h2>
					<v-btn icon color="secondary" @click="closeNotification()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div> -->
				
				<div class="text-center mb-5">
					<h2 style="margin-bottom: 10px; font-size: larger;"
					>Something Went Wrong</h2>
				</div>

				<template v-if="
						$store.state.notification.content &&
						$store.state.notification.content.type == 'NOTIFICATION'
					">
					<div class="text-center" style="color: #c42126; font-size: 14px" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content
							.fieldErrorList">{{ item }}</div>
					<div class="text-center" style="color: #ed5025; font-size: 14px" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content
							.errorList">{{ item }}</div>
					<div class="text-center" style="color: #e26026; font-size: 14px" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content
							.noticeList">{{ item }}</div>
				</template>
				<template v-else>
					<div class="text-center" style="color: #e26026; font-size: 14px">{{ $store.state.notification.content }}</div>
				</template>
				<div class="text-center mt-5 mr-10 ml-10">
					<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
					style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
				</div>
				<div style="text-align: center; margin-top: 20px">
					<v-btn color="#009ec1" @click="closeNotification()">Close</v-btn>
				</div>
				
			</v-card>
		</v-dialog>

		<v-overlay style="z-index: 999;" :value="$root.loader.value" opacity="0">
			<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
		</v-overlay>
	</v-app>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			drawer: true,
			mini: false,
			baseLocation: axios.defaults.baseURL,
			imgError: false,
			showDialogHelp: false,
			message:"",
			isSendMessage: false
		};
	},
	computed: {
		experienceId() {
			return this.$route.params.experienceId;
		}
	},
	methods: {
		deselectExperience() {
			this.$root.selectedExperience = {};
			this.$router.push("/tenant/experience");
		},
		logout() {
			this.$store.dispatch("logout").then(() => {
				this.$router.push("/tenant");
			});
		},
		closeNotification() {
			if (this.$store.state.notification.title === "Unauthorized") {
				this.$store.commit("hideNotification");
				this.$router.push("/tenant");
			} else {
				this.$store.commit("hideNotification");
			}
		},
		sendMessage() {
			var params = {
				tenantId: this.$store.state.principal.tenantId,
				message: this.message,
				currentUrl: this.$router.currentRoute.path
			}
			if (this.experienceId) {
				params = {
					experienceId: this.experienceId,
					message: this.message,
					currentUrl: this.$router.currentRoute.path
				}
			}

			axios
				.post("/system/tenant/help/sendEmail", params)
				.then((response) => {
					if (response.data) {
						this.message = "";
						this.isSendMessage = true;
					}
				});
		},
	}
};
</script>